export const serviceDocuments = [
	// Документы
	{
		name: 'Документы',
		location: 'Общая информация: Документы',
		url: '/info/documents#block1',
	},
	// Дополнительная информация
	{
		name: 'Дополнительная информация',
		location: 'Общая информация: Дополнительная информация',
		url: '/info/additional#block1',
	},
	{
		name: 'Информация о банковском платежном агенте',
		location: 'Общая информация: Дополнительная информация',
		url: '/info/additional#block1Title1',
	},
	{
		name: 'Информация об операторах по переводу денежных средств',
		location: 'Общая информация: Дополнительная информация',
		url: '/info/additional#block1Title2',
	},
	// Логотипы
	{
		name: 'Логотипы',
		location: 'Общая информация: Логотипы',
		url: '/info/logo#block1',
	},
];
